@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	// Needed for additional padding calculations in JS
	--zds-input-content-start-inset-left: var(--zds-input-inset-x);
	--zds-input-content-end-inset-right: var(--zds-input-inset-x);

	display: block;
}

.zds-input-text {
	&__input {
		@include zds-typography('body');

		appearance: none;
		background-color: transparent;
		border: 0;
		color: inherit;
		font-size: var(--zds-input-font-size);
		font-weight: var(--zds-input-font-weight);
		line-height: var(--zds-input-line-height);
		padding: var(--zds-input-inset-y) 0;
		text-align: var(--zds-input-text-align);
		width: 100%;

		&:not(&--plaintext) {
			color: var(--zds-input-color);
		}

		&:focus-visible {
			outline: 0;
		}

		&::placeholder {
			color: var(--zds-input-placeholder-color);
			font-style: var(--zds-input-placeholder-font-style);
		}

		&::-webkit-search-cancel-button {
			display: none;
		}
	}

	&--fit-height {
		height: 100%;
	}

	&--fit-height-with-label {
		display: flex;
		flex-direction: column;
	}
}
